import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { HistoryList, HistoryListSkeleton } from './HistoryList'; // Import skeleton
import { TokenList } from './TokenList';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Terminal } from 'lucide-react';
import type { AddressTransactionsResponse } from '@/lib/hooks/useAPI';
import type { AddressSummaryResponse } from '@/lib/hooks/useAPI';

interface AccountTabsProps {
  accountDetails: AddressSummaryResponse | undefined;
  transfers: AddressTransactionsResponse | undefined;
  isLoadingTransfers: boolean;
  errorTransfers: Error | null;
  currentUserPubkey: string; // Decoded pubkey
  sparkAddress: string; // Add for transfers count
  currentPage: number; // Add current page
  onPageChange: (page: number) => void; // Add page change handler
}

export function AccountTabs({
  accountDetails,
  transfers,
  isLoadingTransfers,
  errorTransfers,
  currentUserPubkey,
  sparkAddress,
  currentPage,
  onPageChange,
}: AccountTabsProps) {
  console.log(accountDetails);
  const hasTokens = (accountDetails?.tokens?.length ?? 0) > 0;
  // Default to history
  const defaultValue = 'history';

  return (
    <Tabs defaultValue={defaultValue} className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="history">History</TabsTrigger>
        <TabsTrigger value="tokens">Tokens</TabsTrigger>
      </TabsList>

      {/* History Tab Content */}
      <TabsContent value="history" className="mt-4">
        {isLoadingTransfers && <HistoryListSkeleton />}
        {errorTransfers && !isLoadingTransfers && (
          <Alert variant="destructive" className="mt-4">
            <Terminal className="h-4 w-4" />
            <AlertTitle>Error Loading History</AlertTitle>
            <AlertDescription>{errorTransfers.message}</AlertDescription>
          </Alert>
        )}
        {!isLoadingTransfers && !errorTransfers && (
          <HistoryList
            transfers={transfers?.data || []}
            currentUserPubkey={currentUserPubkey}
            sparkAddress={sparkAddress}
            currentPage={currentPage}
            onPageChange={onPageChange}
            isLoading={isLoadingTransfers}
            totalTransfers={transfers?.meta?.totalItems || 0}
          />
        )}
      </TabsContent>

      {/* Tokens Tab Content (Still Mock) */}
      <TabsContent value="tokens" className="mt-4">
        {hasTokens ? (
          <TokenList userTokens={accountDetails?.tokens || []} />
        ) : (
          <p className="text-muted-foreground text-center py-10">This account holds no tokens.</p>
        )}
      </TabsContent>
    </Tabs>
  );
}
